module.exports = __webpack_public_path__ + "static/img/DEFAULT_LOGO.65f758b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DEFAULT_LOGO.png
// module id = YSGn
// module chunks = 2